import React from "react";

// route
import { Routes, Route } from "react-router-dom";

// themes
import { GuestTheme } from "../../themes";

// pages
import {
  Register,
  Login,
  ContactUs,
  Landing,
  AboutUs,
  Services,
} from "../../pages/auth";
import { BlogDashboard, ViewBlog } from "../../pages/blog";
import { Training, TrainingDetail } from "../../pages/trainings";
import ForgotPassword from "../../pages/auth/forgot_password";
import TermsAndCondition from "../../pages/terms_and_condition";
import PrivacyPolicy from "../../pages/privacy_policy";
import ComplianceWizard from "../../pages/portal/ComplianceWizard";

const GuestRoutes = () => {
  return (
    <GuestTheme>
      <Routes>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />

        {/* Blogs */}
        <Route path="/blogs" element={<BlogDashboard />} />
        <Route path="/blog/:id" element={<ViewBlog />} />

        {/* trainings */}
        <Route path="/training" element={<Training />} />
        <Route path="/training/:id" element={<TrainingDetail />} />

        {/* policies */}
        {/* privacy policy */}
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        {/* terms and condition */}
        <Route path="/terms-and-condition" element={<TermsAndCondition />} />

        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/prompt" element={<ComplianceWizard />} />
        <Route path="/services" element={<Services />} />
        <Route path="/" element={<Landing />} />
      </Routes>
    </GuestTheme>
  );
};

export default GuestRoutes;
